var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeIconProducts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    fill: "#DBDADA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 4C4.09091 4 3 7 3 7C3 7 4.09091 10 7 10C9.90909 10 11 7 11 7C11 7 9.90909 4 7 4ZM7 4.75C8.91855 4.75 9.88894 6.35016 10.2031 6.99854C9.88858 7.64241 8.91091 9.25 7 9.25C5.08145 9.25 4.11106 7.64984 3.79688 7.00146C4.11178 6.35759 5.08909 4.75 7 4.75ZM7 5.5C6.19673 5.5 5.54545 6.17162 5.54545 7C5.54545 7.82838 6.19673 8.5 7 8.5C7.80327 8.5 8.45455 7.82838 8.45455 7C8.45455 6.17162 7.80327 5.5 7 5.5ZM7 6.25C7.40182 6.25 7.72727 6.58562 7.72727 7C7.72727 7.41438 7.40182 7.75 7 7.75C6.59818 7.75 6.27273 7.41438 6.27273 7C6.27273 6.58562 6.59818 6.25 7 6.25Z",
    fill: "#6C6C6C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIconProducts);
export default __webpack_public_path__ + "static/media/EyeIconProducts.5d5bcc76945176b53dade9bf95f7aab8.svg";
export { ForwardRef as ReactComponent };